import { Box } from '@mui/material';
import { blue, grey, red, teal } from '@mui/material/colors';
import React, { CSSProperties } from 'react';

export interface ScoreBarProps {
  inProgress: boolean;
  limitPercentage: number;
  percentage: number;
}

const ScoreBar = ({ inProgress, percentage, limitPercentage }: ScoreBarProps) => (
  <Box
    style={
      {
        '--color': inProgress ? blue[700] : percentage < limitPercentage ? red[400] : teal[400],
        '--score': `${percentage}%`,
        '--limit': `${limitPercentage}%`,
      } as CSSProperties
    }
    sx={{
      backgroundImage: `linear-gradient(to right, ${grey[400]} 0%, ${grey[400]} var(--limit), ${grey[200]} var(--limit), ${grey[200]} 100%);`,
      borderRadius: 20,
      height: 8,
      mb: 3,
      position: 'relative',
      '::before': {
        backgroundColor: 'var(--color)',
        borderRadius: '4px',
        content: '""',
        height: '100%',
        position: 'absolute',
        width: 'var(--score)',
      },
      '::after': {
        backgroundColor: grey[700],
        content: '""',
        height: '18px',
        position: 'absolute',
        left: 'var(--limit)',
        top: -5,
        width: '1px',
      },
    }}
  />
);

export default ScoreBar;
